<template>
  <div class="more-info--wrap dimmed" @click.self="$emit('onCloseClick')">
    <div :class="isAMP ? 'amp' : ''">
      <table>
        <caption>
          <b v-html="rankTitle"></b>
          <span v-html="rankNotice"></span>
        </caption>
        <thead>
        <tr>
          <th width="85">{{ $t('common.table.header.rank') }}</th>
          <th width="85">{{ valueUnit }}</th>
          <th width="175">{{ $t('common.table.header.image') }}</th>
          <template v-if="['zoomin', 'zoomout'].includes(type)">
            <th width="212"><span v-html="$t('common.table.header.zoomInRate')"></span></th>
            <th width="212"><span v-html="$t('common.table.header.zoomOutRate')"></span></th>
          </template>
          <template v-else>
            <template v-if="isDesktopDevice">
              <th width="85">{{ $t('common.table.header.clickRate') }}</th>
              <th width="85"><span v-html="$t('common.table.header.scrollToClick')"></span></th>
              <th width="85"><span v-html="$t('common.table.header.clickPvRate')"></span></th>
              <th width="85" v-if="!isAMP"><span v-html="$t('common.table.header.hoverClickTime')"></span></th>
              <th width="85" v-if="!isAMP"><span v-html="$t('common.table.header.hoverToClick')"></span></th>
            </template>
            <template v-else>
              <th width="106">{{ $t('common.table.header.tapRate') }}</th>
              <th width="106"><span v-html="$t('common.table.header.scrollToTap')"></span></th>
              <th width="106"><span v-html="$t('common.table.header.tapPvRate')"></span></th>
              <th width="106"><span v-html="$t('common.table.header.dblTapRate')"></span></th>
            </template>
          </template>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in rankList" :key="index">
          <td width="85" class="data-rank">
            <span>{{ index + 1 | rank }}</span>
          </td>
          <td width="85" class="data-clicks">
            <span>{{ getRankValue(item) | thousand }}</span>
          </td>
          <td width="175" class="data-image">
            <figure>
              <crop-image :url="imageData.url"
                :imageWidth="imageData.width"
                :imageHeight="imageData.height"
                :width="item.width"
                :height="item.height"
                :maxWidth="170"
                :maxHeight="40"
                :offset="{ x: item.left, y: item.top }"/>
            </figure>
          </td>
          <template v-if="['zoomin', 'zoomout'].includes(type)">
            <td width="212" class="data-hover-click-time" v-if="!isAMP">
              <span>{{ item.zoominRate | fixed(1) }} %</span>
            </td>
            <td width="212" class="data-hover-to-click" v-if="!isAMP">
              <span>{{ item.zoomoutRate | fixed(1) }} %</span>
            </td>
          </template>
          <template v-else>
            <template v-if="isDesktopDevice">
              <td width="85" class="data-click-rate">
                <span>{{ item.clickRate | fixed(1) }} %</span>
              </td>
              <td width="85" class="data-scroll-to-click">
                <span>{{ item.scrollPvToPv | scrollPvToPv }} %</span>
              </td>
              <td width="85" class="data-click-pv-rate">
                <span>{{ item.clickPvRate | fixed(1) }} %</span>
              </td>
              <td width="85" class="data-hover-click-time" v-if="!isAMP">
                <span>{{ item.hoverClickTime | fixed(1) }} sec</span>
              </td>
              <td width="85" class="data-hover-to-click" v-if="!isAMP">
                <span>{{ item.hoverClickRate | fixed(1) }} %</span>
              </td>
            </template>
            <template v-else>
              <td width="106" class="data-click-rate">
                <span>{{ item.tapRate | fixed(1) }} %</span>
              </td>
              <td width="106" class="data-scroll-to-click">
                <span>{{ item.scrollPvToPv | scrollPvToPv }} %</span>
              </td>
              <td width="106" class="data-click-pv-rate">
                <span>{{ item.tapPvRate | fixed(1) }} %</span>
              </td>
              <td width="106" class="data-hover-click-time">
                <span>{{ item.doubleTapRate | fixed(1) }} %</span>
              </td>
            </template>
          </template>
        </tr>
        </tbody>
      </table>
      <button @click="$emit('onCloseClick')">
        <i class="icon icon--close-btn"></i>
      </button>
    </div>
  </div>
</template>

<script>
import CropImage from '@/components/ui/CropImage'

export default {
  name: 'RankList',
  components: {
    CropImage
  },
  props: [
    'type',
    'rankList',
    'imageData',
    'isAMP',
    'isDesktopDevice'
  ],
  computed: {
    valueUnit () {
      switch (this.type) {
        case 'click':
          return 'Clicks'
        case 'pv':
          return 'PV'
        case 'tap':
          return 'Tap'
        case 'zoomin':
          return 'Zoom In'
        case 'zoomout':
          return 'Zoom Out'
        case 'hover':
          return 'Hovers'
        default:
          throw new Error(`invalid type: ${this.type}`)
      }
    },
    rankTitle () {
      switch (this.type) {
        case 'click':
          return this.$t('reporting.click.clickCount.summary.title')
        case 'pv':
          return this.$t('reporting.click.pvCount.summary.title')
        case 'tap':
          return this.$t('reporting.tap.tapCount.summary.title')
        case 'zoomin':
          return this.$t('reporting.zoom.zoomin.summary.title')
        case 'zoomout':
          return this.$t('reporting.zoom.zoomout.summary.title')
        case 'hover':
          return this.$t('reporting.move.subTitle')
        default:
          throw new Error('invalid type')
      }
    },
    rankNotice () {
      switch (this.type) {
        case 'click':
          return this.$t('reporting.click.clickCount.summary.notice')
        case 'pv':
          return this.$t('reporting.click.pvCount.summary.notice')
        case 'tap':
          return this.$t('reporting.tap.tapCount.summary.notice')
        case 'zoomin':
          return this.$t('reporting.zoom.zoomin.summary.notice')
        case 'zoomout':
          return this.$t('reporting.zoom.zoomout.summary.notice')
        case 'hover':
          return this.$t('reporting.move.notice')
        default:
          throw new Error('invalid type')
      }
    }
  },
  methods: {
    getRankValue (item) {
      switch (this.type) {
        case 'click':
          return item.clickCount
        case 'pv':
          return item.pvCount
        case 'tap':
          return item.tapCount
        case 'zoomin':
          return item.zoominCount
        case 'zoomout':
          return item.zoomoutCount
        case 'hover':
          return item.hoverCount
        default:
          throw new Error('invalid type')
      }
    }
  }
}
</script>

<style lang="scss">
.more-info--wrap {
  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 830px;
    height: 574px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    color: #666666;
    padding: 30px 30px 35px;
    box-sizing: border-box;
    overflow: hidden;
  }

  & > div.amp {
    width: 660px !important;
  }

  table {
    width: 100%;
    text-align: center;
    table-layout: fixed;
    border-collapse: collapse;

    caption {
      text-align: left;
      font-size: 15px;
      font-weight: 600;
      color: #2f2f2f;
      margin-bottom: 50px;

      span {
        font-size: 12px;
        color: $brandColor;
        margin-left: 20px;
        display: inline-block;
      }
    }

    thead tr{
      display: block;
      th {
        padding-bottom: 8px;
        border-bottom: 1px solid #bbbbbb;
        line-height: 1.23;
        font-size: 13px;
        color: #666666;

        span {
          display: inline-block;
          white-space: nowrap;
          width: 63px;
          text-align: right;
          position: relative;
          left: -10px;
        }
      }
    }

    tbody {
      display: block;
      overflow: auto;
      width: 100%;
      height: 420px;
      color: #2f2f2f;

      tr {
        height: 50px;
        border-bottom: 1px solid #ebebeb;
        box-sizing: border-box;
      }
    }
  }

  button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 12px;
  }
}
</style>
